import { call, put } from 'redux-saga/effects';

import { setBannersActiveAction } from '../actions/bannerAction';
import Services from '../services/index';

export function* getBannersActiveSaga() {
  try {
    const response = yield call(Services.BannerService.getBannersActive);
    yield put(setBannersActiveAction(response));
  } catch (error) {}
}
